<template>
	<div v-if="loaded">
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/campaigns/">All Bookblock HUB Campaigns</router-link>  &gt;
			<router-link class="breadcrumb-link" :to="'/campaigns/' + item.id">{{ item.name }}</router-link>  &gt;
            <router-link class="breadcrumb-link" :to="'/campaigns/' + item.id + '/feedback'">Feedback</router-link>
		</div>
		<h3>{{ item.name }} <span>Negative Feedback</span></h3>

        <div class="ws-large-tab-menu">
			<router-link :to="'/campaigns/' + item.id">Summary</router-link>
			<router-link :to="'/campaigns/' + item.id + '#recipients'">Recipients</router-link>
			<router-link :to="'/campaigns/' + item.id + '/feedback'">Feedback</router-link>
		</div>

		<!--
		<div class="ws-filters">
			<div class="ws-filter ws-filter-rejected">
				<label>Feedback</label>
				<div class="ws-filter-switch" :data-state="filterToYesNo('feedback')" @click="toggleFilter('feedback')"><div class="ws-filter-switch-knob"></div></div>
			</div>
		</div>
		-->

		<div class="large-table-wrap">
			<table id="list-of-recipients"  class="worksends-table cb-table status-">
				<thead>
				<tr>
					<th class="field-r_name"><div class="sortable" :class="sortClass('last_name', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('last_name')">Customer</div></th>
					<th class="field-review-date"><div class="sortable" :class="sortClass('visited_at', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('visited_at')">Reviewed At</div></th>
					<th class="field-rating"><div class="sortable" :class="sortClass('rating', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('rating')">Rating</div></th>
					<th class="field-feedback"><div>Feedback</div></th>
					<th class="field-actions">Actions</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="r, i in registrations.data" :registration-id="r.id" >
					<td class="field-r_name" data-label="Recipient">
						<div class="value"><b>{{ r.first_name }} {{ r.last_name }}</b></div>
						<div class="value">{{ r.email }}</div>
					</td>
					<td class="field-review_date" data-label="Review Date">
						<div class="value">{{ r.visited_at }}</div>
					</td>
					<td class="field-rating" data-label="Rating">
						<div class="value"><div :class="'feedback-rating rating-'+r.rating" @click="openFeedbackModal(r)">{{ verbalRating(r.rating) }}</div></div>
					</td>

					<td class="field-feedback" data-label="Feedback">
						<div class="value customer-feedback-text">{{ trimText(r.feedback,200) }}</div>
					</td>

					<td class="field-actions" data-label="Actions" style="width: 130px;" >
						<div class="value">
							<div class="ws-button small" @click="openFeedbackModal(r)">View Details</div>
						</div>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
		<ws-table-meta :meta="registrations.meta" :sum="'There are % gift registrations with negative feedback in total.'"></ws-table-meta>

		<feedback-modal v-if="modals.feedbackModal" :registration="feedbackRegistration"></feedback-modal>
	</div>
</template>

<script>

import FeedbackModal from "@/pages/gift-box-campaigns/GiftBoxCampaignsFeedbackModal";

export default {
	name: "GiftBoxCampaignsFeedbackPage",
	components: {FeedbackModal},
	data() {
		return {
			loaded: false,
			feedbackRegistration: null,
			pageParams: {
				pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 10},
				search: {val: ""},
				filters: {
					feedback: { val: true, type: 'single' },
				}
			},
		}
	},
	methods: {
		getPage(params) {
			this.getPageHandler({
				waitName: 'gb_registrations.feedback',
				action: 'fetchCampaignGiftBoxRegistrations', // vuex action
				routeParams: {campaignId: this.$route.params.id},
				pageParams: this.pageParams,
				isInit: false, // parse from url query params
				pushRoute: false, // push pagination params and search q to route
				resetPagination: params ? params.resetPagination : false // new search input || filters -> need to reset page & sorting
			});
			this.fetchData();
		},
		async fetchData() {
			await this.dispatchWaitAndNotify('fetchGiftBoxCampaign', {
				campaignId: this.$route.params.id,
			}, false, true);
			this.loaded = true;
		},
		filterToYesNo(filter) {
			return this.pageParams.filters[filter].val === true ? 'yes' : (this.pageParams.filters[filter].val === false ? 'no' : 'all');
		},
		toggleFilter(filter, nullable = true) {
			if (this.pageParams.filters[filter].val === null) this.pageParams.filters[filter].val = true;
			else if (this.pageParams.filters[filter].val === true) this.pageParams.filters[filter].val = false;
			else if (this.pageParams.filters[filter].val === false) this.pageParams.filters[filter].val = nullable ? null : true;
			else { return; }
			this.getPage({resetPagination: true});
		},
		sortClass(field, sortBy, sortDesc) { // pageOptions param just to be reactive
			if (this.pageParams.pageOptions.sortBy && this.pageParams.pageOptions.sortBy[0] === field) {
				return {'sort': true, 'sort-up': !this.pageParams.pageOptions.sortDesc[0], 'sort-down': this.pageParams.pageOptions.sortDesc[0]};
			}
			return {};
		},
		verbalRating(rating) {
			if (this.item.reviews && this.item.reviews.buttons && this.item.reviews.buttons[rating]) return this.item.reviews.buttons[rating];
			else return 'Unknown';
		},
		openFeedbackModal(r) {
			this.feedbackRegistration = r;
			this.modals.feedbackModal = true;
		},
		trimText(text,length) {
			return text.substring(0, length) + (text.length > length ? '...':'');
		}
	},
	mounted() {
		this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
		this.getPage();
	},
	computed: {
		team() {
			return this.$store.state.team.detail;
		},
		user() {
            return this.$store.state.currentUser;
        },
		item() {
			return this.$store.state.giftBoxCampaign.detail;
		},
		registrations() {
			return this.$store.state.giftBoxCampaign.registrations;
		},
		modals() {
			return this.$store.state.modals;
		},
	},
}
</script>

<style>

</style>
